/**
 * PlayerAssetsPage — V2 list shell shared by the player-asset catalogs
 * (avatars, player backgrounds, app music). Same PageHeader recipe as
 * BackgroundMusicPageV2.
 */
import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { PageHeader, Button } from "../../redesign";
import PlayerAssetsTable from "./PlayerAssetsTable";

const PlusSign = (
  <span style={{ fontSize: 16, lineHeight: 1 }} aria-hidden>
    +
  </span>
);

const PlayerAssetsPage = ({ config }) => {
  const total = useSelector(state => state.player_assets.byType[config.type]?.length);
  const totalLabel = total != null ? `${total.toLocaleString()} total` : undefined;

  return (
    <div className="bg-bg min-h-full">
      <PageHeader
        eyebrow="Player Customization"
        title={config.label}
        total={totalLabel}
        actions={
          <Link to={`${config.basePath}/add`} className="no-underline">
            <Button variant="coral" leadingIcon={PlusSign}>
              Add {config.singular}
            </Button>
          </Link>
        }
      />
      <PlayerAssetsTable config={config} />
    </div>
  );
};

export default PlayerAssetsPage;
